var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('p',[_vm._v(" Redirecting... "),_c('a',{staticClass:"text-decoration-underline",attrs:{"to":'/'}},[_vm._v("Click here")]),_vm._v(" if you haven't been redirected automatically ")])])}
var staticRenderFns = []

export { render, staticRenderFns }